<template>
  <div class='flex flex-col'>
    <div v-for="(cp, index) in activeConsults" :key="index" @click="selectFromConnectedList(cp.channelId, cp.customerId)"
      :class="(cp.channelId === activeChannel) ? 'bg-grey-extralight': ''" 
      class="flex flex-col px-3 py-4 flex-no-shrink flex-no-grow border-b border-solid border-grey-lightest cursor-pointer hover:bg-grey-extralight">
        <div class="flex flex-row justify-between mb-2 h-4 items-center">
          <div class="text-m font-semibold text-grey-darker capitalize mr-1"> {{cp.name ? cp.name: cp.customerId}}</div>
          <div v-if="cp.isOnline" class="self-center bg-green flex-no-shrink flex-no-grow mr-auto" style="height:10px; width: 10px; border-radius: 50%"/>
          <div v-else-if="!cp.isOnline" class="self-center bg-red flex-no-shrink flex-no-grow mr-auto" style="height:10px; width: 10px; border-radius: 50%"/>
          <div class="flex-no-shrink flex-no-grow text-xs font-semibold" v-if="cp.consultationRequest.status === 'accepted'"><time-elapsed :key="cp.customerId" v-on:timerColor="timerColor" :time="cp.accepted_at"/></div>
          <div class="flex-no-shrink flex-no-grow ml-1" v-if="cp.isFamilyDoctor && cp.consultationRequest.status === 'accepted'"><img src="../../assets/personal_patient.svg" alt="Personal Patient" style="width:20px; height:20px"></div>
          <div class="flex-no-shrink flex-no-grow py-1 px-2 self-center text-brown text-xs font-semibold justify-center items-center" v-if="cp.isFamilyDoctor && cp.consultationRequest.status === 'query_accepted' && (cp.consultationRequest.request_type === 'queried' || cp.consultationRequest.request_type === 'missed')" style="border-radius: 25px; color:#70411b; background-color:#faedce" >Query</div>
        </div>
        <div class="flex flex-row h-4">
          <div class="flex justify-start items-center w-64 truncate">
            <div v-if="cp.isOnline && cp.isCustomerTyping === true" class="text-sm font-light text-grey-dark truncate">User is typing ...</div>
            <div v-else class="text-sm font-light text-grey-dark truncate">{{patientLastMessage(cp.channelId)}}</div>
            <div v-if="patientNewMessages(cp.channelId) > 0" class="flex flex-col self-center font-semibold text-xs text-grey-darker bg-yellow-light rounded-full px-2 py-1 flex-no-shrink flex-no-grow ml-auto">{{patientNewMessages(cp.channelId)}} Unread</div>
          </div>
          <div class="flex flex-row justify-end items-center ml-auto w-24">
            <div class="text-xs font-light text-grey-dark">{{patientLastMessageTime(cp.channelId)}}</div>
          </div>
        </div>
    </div>
    <UnsavedChangesModal v-if="showSaveReminder" @close='closeModal'/>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import UnsavedChangesModal from '@/components/common/modals/UnsavedChanges'
import TimeElapsed from './TimeElapsed.vue'

export default {
  components: {
    UnsavedChangesModal,
    TimeElapsed
  },
  data () {
    return {
      showSaveReminder: false,
      timerClass: 'text-green-darker'
    }
  },
  computed: {
    ...mapState({
      activeConsults: state => state.consultation.activeConsults,
      activeCustomer: state => state.consultation.activeCustomerId,
      activeChannel: state => state.consultation.activeChannelId,
      editTextField: state => state.textField.inEdit
    }),
    ...mapGetters({
      allMessages: 'message/getAllPatientsMessages'
    })
  },
  methods: {
    selectFromConnectedList: function (channelId, customerId) {
      if (this.editTextField) {
        this.showSaveReminder = true
        return
      }
      if (channelId !== this.activeChannel) {
        this.$store.dispatch('consultation/switchTo', {channelId: channelId, customerId: customerId})
      }
    },
    patientLastMessage: function (channelId) {
      let consult = this.allMessages.find(function (ele) {
        return (ele.channelId === channelId)
      })
      if (consult) {
        let patientMessages = consult.messages.filter(function (ele) {
          return (ele.user && ele.user.type === 'customer')
        })
        if (patientMessages.length > 0) {
          if (patientMessages[patientMessages.length - 1].intentName === 'incoming_text') {
            return patientMessages[patientMessages.length - 1].payload.text.substring(0, 45)
          } else if (patientMessages[patientMessages.length - 1].intentName === 'file_customer') {
            return patientMessages[patientMessages.length - 1].payload.file_name.substring(0, 45)
          }
        }
      }
      return ''
    },
    patientLastMessageTime: function (channelId) {
      let consult = this.allMessages.find(function (ele) {
        return (ele.channelId === channelId)
      })
      if (consult) {
        let patientMessages = consult.messages.filter(function (ele) {
          return (ele.user && ele.user.type === 'customer')
        })
        if (patientMessages.length > 0) {
          let milliTime = patientMessages[patientMessages.length - 1].uniqueId
          let t = new Date(Number(milliTime))
          return t.toLocaleTimeString('en-US', {hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Kolkata'})
        }
      }
      return ''
    },
    patientNewMessages: function (channelId) {
      let consult = this.allMessages.find(function (ele) {
        return (ele.channelId === channelId)
      })
      if (consult) {
        let patientMessages = consult.messages
        if (patientMessages.length > 0) {
          if (this.activeChannel !== channelId) {
            return consult.newMessages
          }
        }
        return 0
      }
    },
    closeModal: function (params) {
      this.showSaveReminder = false
    },
    timerColor: function (value) {
      this.timerClass = value
    }
  }
}
</script>

<style>
.patientActive {
  background-color: #f5f7f9
}

</style>



// WEBPACK FOOTER //
// src/components/Consultations/ActiveConsultations.vue